import { put, select } from "redux-saga/effects";
import { getMailchimpAuthURLFailure, getMailchimpAuthURLSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";

export function* handleGetMailchimpAuthURL(): Generator<any, void, any> {
    try {
        const formId: string = yield select(state => state.forms.current._id);
        const data = yield IntegrationService.getMailchimpAuthURL(formId);
        yield put(
            getMailchimpAuthURLSuccess({
                success: true,
                message: "",
                data: data.data.data,
            }),
        );
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to get Mailchimp authentication URL";
        yield put(getMailchimpAuthURLFailure(errorMessage));
    }
}
